<template lang="pug">
form(@submit.prevent="onSubmit" class="grid grid-cols-1 md:grid-cols-2 gap-4")
  div(class="md:col-span-2 flex flex-col")
    .form-group(v-if="Object.keys(errors).length")
      .alert.error_explanation
        form-error(:errors="errors")

  .flex.flex-col
    label#rm_contact_firstname(class="inline-flex font-medium mb-2" for="rm_contact_firstname") Prénom*
    input#rm_contact_firstname.form-control(v-model="contact.firstname" type="text" required="required" placeholder="Votre prénom" :class="{'field_with_errors': errors.lastname}" class="block mt-1 px-6 placeholder-gray-100 placeholder-opacity-60 text-gray h-input-rental-management p-2 border border-gray-300 rounded-16 focus:outline-none focus:ring-0")

  .flex.flex-col
    label#rm_contact_lastname(class="inline-flex font-medium mb-2" for="rm_contact_lastname") Nom*
    input#rm_contact_lastname.form-control(v-model="contact.lastname" type="text" required="required" placeholder="Votre nom" :class="{'field_with_errors': errors.lastname}" class="block mt-1 px-6 placeholder-gray-100 placeholder-opacity-60 text-gray h-input-rental-management p-2 border border-gray-300 rounded-16 focus:outline-none focus:ring-0")

  .flex.flex-col
    label#rm_contact_email(class="inline-flex font-medium mb-2" for="rm_contact_email") Email*
    input#rm_contact_email.form-control(v-model="contact.email" type="email" required="required" placeholder="Votre e-mail" :class="{'field_with_errors': errors.base}" class="block mt-1 px-6 placeholder-gray-100 placeholder-opacity-60 text-gray h-input-rental-management p-2 border border-gray-300 rounded-16 focus:outline-none focus:ring-0")

  .flex.flex-col
    label#rm_contact_phone(class="inline-flex font-medium mb-2" for="rm_contact_phone") Téléphone*
    input#rm_contact_phone.form-control(v-model="contact.phone" type="phone" required="required" placeholder="Votre téléphone" :class="{'field_with_errors': errors.lastname}" class="block mt-1 px-6 placeholder-gray-100 placeholder-opacity-60 text-gray h-input-rental-management p-2 border border-gray-300 rounded-16 focus:outline-none focus:ring-0")

  .flex.flex-col(v-if="subjects.length > 0")
    label#rm_contact_subject(class="inline-flex font-medium mb-2" for="rm_contact_subject") Je cherche
    select#rm_contact_subject.form-control(v-model="contact.subject" required="required" class="block mt-1 bg-white px-6 placeholder-gray-100 placeholder-opacity-60 text-gray h-input-rental-management p-2 border border-gray-300 rounded-16 focus:outline-none focus:ring-0")
      option(v-for="(subject, index) in subjects" :key="index" :value="subject.value") {{ subject.label }}

  .flex.flex-col
    label#rm_contact_geographical_zone(class="inline-flex font-medium mb-2" for="rm_contact_geographical_zone") Zone géographique
    input#rm_contact_geographical_zone.form-control(v-model="contact.geographical_zone" type="text" placeholder="Votre ville" :class="{'field_with_errors': errors.base}" class="block mt-1 px-6 placeholder-gray-100 placeholder-opacity-60 text-gray h-input-rental-management p-2 border border-gray-300 rounded-16 focus:outline-none focus:ring-0")

  div(class="md:col-span-2 flex flex-col")
    label#rm_contact_geographical_message(class="inline-flex font-medium mb-2" for="rm_contact_geographical_message") Message*
    textarea#rm_contact_message.form-control(v-model="contact.message" rows="5" required="required" placeholder="Votre message" :class="{'field_with_errors': errors.message}" class="min-h-200 block mt-1 px-6 placeholder-gray-100 placeholder-opacity-60 text-gray h-input-rental-management p-2 border border-gray-300 rounded-16 focus:outline-none focus:ring-0")

  div(class="md:col-span-2 flex items-start space-x-2")
    input(type="checkbox" name="rgpd_terms_accepted" id="rm_contact_rgpd_terms_accepted" value="true" v-model="contact.rgpd_terms_accepted" class="mt-1")
    label.text-14.opacity-60(for="rm_contact_rgpd_terms_accepted")
      | En soumettant ce formulaire, j’accepte que les informations saisies dans ce formulaire soient utilisées, exploitées, traitées pour permettre de me recontacter. Découvrez comment nous recueillons, utilisons et partageons vos données en lisant notre Politique d’utilisation des données.

  div(class="md:col-span-2 flex justify-center mt-4")
    vue-recaptcha(
      ref="recaptcha"
      size="invisible"
      :sitekey="recaptchaAppKey"
      @verify="onCaptchaVerify"
      @expired="onCaptchaExpired"
    )

  div(class="md:col-span-2 flex justify-center mt-4")
    input(type="submit" :id="submitButtonId" :disabled="!canSubmit" value="Envoyer" class="btn btn-rounded btn-tertiary text-white flex-shrink-0 px-12 mt-10")

  div(class="md:col-span-2 text-center mt-12 text-14")
    | Les champs marqués d'une * sont obligatoires
</template>

<script>
import ContactForm from '@components/ContactForm'

export default {
  extends: ContactForm
}
</script>
